// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loading_loadingWrapper__QCtS2","loaderGif":"Loading_loaderGif__gwFBi"};